import { CancelToken } from 'axios';
import { DefaultState, MassAddResponse, MassAddRow } from 'store/types';

export const ROOM_MASS_ADD_DATA_REQUEST = 'ROOM_MASS_ADD_DATA_REQUEST';
export const ROOM_MASS_ADD_DATA_SUCCESS = 'ROOM_MASS_ADD_DATA_SUCCESS';
export const ROOM_MASS_ADD_DATA_FAILURE = 'ROOM_MASS_ADD_DATA_FAILURE';

export interface RoomMassAddRow extends MassAddRow {
  reservationId: string;
  from: string;
  to: string;
  type: string;
  rate: string;
  occupancy: string;
  reservationProviderId: string;
  reservationProviderName: string;
  clcRequestNumber?: string;
}

export interface RoomMassAddParams {
  data: FormData;
  onUploadProgress: (progressEvent: any) => void;
  cancelToken: CancelToken;
};

export type RoomMassAddData = MassAddResponse<RoomMassAddRow>

export type RoomMassAddState = DefaultState & {
  contents?: RoomMassAddData;
};

interface RoomMassAddDataRequest {
  type: typeof ROOM_MASS_ADD_DATA_REQUEST;
}

interface RoomMassAddDataSuccess {
  type: typeof ROOM_MASS_ADD_DATA_SUCCESS,
  contents: RoomMassAddData;
}

interface RoomMassAddDataFailure {
  type: typeof ROOM_MASS_ADD_DATA_FAILURE;
}

export type RoomMassAddActionTypes = RoomMassAddDataRequest | RoomMassAddDataSuccess | RoomMassAddDataFailure;